import React from 'react'

function Brand() {
    return (
        <div>Brand</div>
    )
}

export default Brand